module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_40.f3c66e32.gif";